import React from 'react';
import { Link } from 'react-router-dom';
import type { MountGuideRegionCard } from '../../types';
import { resolvePublicMediaUrl } from '../../utils/newsContent';
import { guideText } from '../../utils/guideLocale';
import type { Locale } from '../../translations';

type Props = {
    regions: MountGuideRegionCard[];
    locale: Locale;
    search?: string;
};

const MountGuideRegionGrid: React.FC<Props> = ({ regions, locale, search = '' }) => {
    const q = search.trim().toLowerCase();
    const filtered = q
        ? regions.filter((r) => {
              const title = guideText(locale, r.titleEn, r.titlePtBr).toLowerCase();
              return title.includes(q);
          })
        : regions;

    if (filtered.length === 0) {
        return <p className="mount-guide-empty">—</p>;
    }

    return (
        <ul className="mount-guide-region-grid">
            {filtered.map((region) => {
                const title = guideText(locale, region.titleEn, region.titlePtBr);
                const thumb = resolvePublicMediaUrl(region.thumbnailUrl);
                return (
                    <li key={region.id}>
                        <Link to={`/game/montarias/${region.slug}`} className="mount-guide-region-card">
                            <span className="mount-guide-region-name">{title}</span>
                            <span className="mount-guide-region-thumb">
                                {thumb ? (
                                    <img src={thumb} alt={title} loading="lazy" />
                                ) : (
                                    <span className="mount-guide-region-thumb--placeholder" aria-hidden>
                                        <i className="ri-map-pin-line" />
                                    </span>
                                )}
                            </span>
                        </Link>
                    </li>
                );
            })}
        </ul>
    );
};

export default MountGuideRegionGrid;
